<template>
    <div>
        <v-dialog v-model="abrir" width="500" persistent >
            <v-card class="pb-1">
                <v-card-title class="justify-space-between">
                    <span class="headline">Subir archivo</span>
                    <div>
                        <v-btn class="mx-2" color="red darken-1" dark @click="cerrarModal">Cerrar</v-btn>
                    </div>
                </v-card-title>
                <v-col cols="12">
                    <v-col>
                        <v-file-input
                            id="input_archivo"
                            @change="cambioArchivo"
                            v-model="archivo" 
                            label="Agregue Archivo" 
                            accept=".pdf"
                            outlined 
                        >
                        </v-file-input>
                    </v-col>
                    <v-col class="d-flex justify-center">
                        <v-btn class="mx-2 mr-2" v-if="url_archivo" color="red darken-1"  :dark="true" @click="eliminarArchivo" title="Eliminar archivo"><v-icon>delete</v-icon>ELIMINAR</v-btn>
                        <v-btn class="mx-2 mr-2" v-if="url_archivo" color="green darken-1"  :dark="true" @click="descargarArchivo" title="Descargar archivo"><v-icon>get_app</v-icon> DESCARGAR</v-btn>
                        <v-btn color="green darken-1"  :dark="!desactivar_importar" :disabled="desactivar_importar" @click="subirArchivo"><v-icon>publish</v-icon> Subir</v-btn>
                    </v-col>
                </v-col>
            </v-card>
            <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        </v-dialog>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'

export default {
    data() {
        return {
            abrir: false,
            archivo: {},
            url_archivo: "",
            formatos_aceptados: ['application/pdf'],
            config: {},
            dato: {},
        }
    },
    mounted(){
        this.$parent.$on('abrir_modal_archivo', (item, config) => {
            this.dato = item;
            this.config = config;
            console.log({ item });
            this.buscarArchivo();
        });
    },
    methods: {
        cerrarModal() {
            this.abrir = false;
            this.archivo = {};
            this.url_archivo = "";
        },

        cambioArchivo(){
            console.log('archivo',this.archivo);
            if(this.archivo) {
                // Busca entre los formatos aceptados
                const aceptado = this.formatos_aceptados.find(formato => formato === this.archivo.type);
                
                // Solo se acepta archivos PDF
                if(aceptado == undefined) this.archivo = {};
            }
        },

        async buscarArchivo() {
            const info_cargar = {...this.config.info_cargar};
            const url = info_cargar.url;

            if(info_cargar && info_cargar.cargar) {
                this.mostrarLoading({ titulo:`Obteniendo información de archivo de ${this.config.view}...`, color:'blue' });

                await this.axios.get(url, this.headers).then(res => {
                    if(info_cargar.ubicacion) {
                        this.url_archivo = res.data.data[info_cargar.ubicacion].url_archivo;
                    } else {
                        this.url_archivo = res.data.data.url_archivo;
                    }
                    console.log(this.url_archivo);

                    this.ocultarLoading();
                    this.abrir = true;
                }).catch(error => {
                    console.error('error', error);
                    this.errorMessage(error, "Error al buscar información");
                });
            } else {
                this.url_archivo = url;
                this.abrir = true;
            }
            
        },
        async subirArchivo() {
            const info_subir = {...this.config.info_subir};
            const url = info_subir.url;
            
            // Subiendo el archivo
            this.mostrarLoading({ titulo:'Subiendo Archivo...', color:'blue' })
            let token = this.headers.headers['Authorization'];
            let cabecera = {
                headers:{
                    'Authorization':token,
                    'Content-Type':'multipart/form-data'
                }
            }
            let body = new FormData();
            body.append('archivo', this.archivo);
            console.log('headers',cabecera);
            await this.axios.post(url, body, cabecera).then(res => {
                this.mostrarLoading({titulo:'¡Archivo subido con éxito!',color:'green'})
                console.log(res);
                this.abrir = false;

                this.dato.url_archivo = res.data.data;
                this.$emit("recargar_desde_modal_archivo");
            }).catch(error => {
                console.error('error', error);
                this.errorMessage(error, "Error al subir archivo");
            });
        },

        async descargarArchivo() {
            const info_descargar = {...this.config.info_descargar};
            let url  = info_descargar.url;
            
            //Descargando el archivo
            this.mostrarLoading({ titulo:'Descargando Archivo...', color:'blue' })
            await this.axios.get(url,this.headers).then(res => {
                if(!res.error) {
                    url = this.download_url.replace('bitacoras', info_descargar.path)     
                    window.location.href = url + res.data.data;
                } else {
                    throw new Error("Ha ocurrido un error");
                }
            }).catch(error => {
                console.error('error', error);
                this.errorMessage(error, "Error al descargar archivo");
            });
        },

        async eliminarArchivo() {
            const info_eliminar = {...this.config.info_eliminar}
            const url = info_eliminar.url;

            const ok = await this.$refs.confirmDialogue.show({
                title: 'Confirmar eliminación',
                message: info_eliminar.confirm_message || `¿Desea eliminar el archivo de esta(e) ${this.config.view}?`,
                okButton: 'Eliminar',
            })

            if(ok) {
                // Eliminando el archivo
                this.mostrarLoading({titulo:'Eliminando Archivo...',color:'blue'})
                let token = this.headers.headers['Authorization'];
                let cabecera = {
                    headers:{
                        'Authorization': token,
                        'Content-Type':'multipart/form-data',
                    }, 
                    responseType: "blob",
                }

                await this.axios.delete(url, cabecera).then(res => {
                    console.log(res);
                    this.dato.url_archivo = "";
                    this.url_archivo = "";

                    this.abrir = false;
                    this.ocultarLoading();
                }).catch(error => {
                    console.error('error', error);
                    this.errorMessage(error, "Error al eliminar archivo");
                });
            }
            
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        desactivar_importar(){
            if(this.archivo && this.archivo != {}){
                let aceptado = this.formatos_aceptados.find(formato => formato === this.archivo.type);
                return aceptado === undefined ? true : false;
            }
            return true;
        },
        ...mapState(['base_url','headers', 'download_url'])
    }, 
    components: {
        ConfirmDialogue,
    }
}
</script>

<style>
</style>